import ExpertiseSelect from './expertise-select';

export default ExpertiseSelect;
